export default __webpack_public_path__ + "static/media/boop.eaf4ce9d.mp3";